import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const teaser = {
  createTeaser: lazyModuleMethod(() => import('./createTeaser'), 'default'),
  deleteTeaser: lazyModuleMethod(() => import('./deleteTeaser'), 'default'),
  fetchTeasers: lazyModuleMethod(() => import('./fetchTeasers'), 'default'),
  updateTeaser: lazyModuleMethod(() => import('./updateTeaser'), 'default'),
  fetchTeaserById: lazyModuleMethod(
    () => import('./fetchTeaserById'),
    'default'
  ),
  createTeaserItem: lazyModuleMethod(
    () => import('./createTeaserItem'),
    'default'
  ),
  fetchTeaserItem: lazyModuleMethod(
    () => import('./fetchTeaserItem'),
    'default'
  ),
  deleteTeaserItem: lazyModuleMethod(
    () => import('./deleteTeaserItem'),
    'default'
  ),
  updateTeaserItem: lazyModuleMethod(
    () => import('./updateTeaserItem'),
    'default'
  ),
  copyTeaser: lazyModuleMethod(() => import('./copyTeaser'), 'default'),
}
